import { render, staticRenderFns } from "./browse-configurations-root.view.vue?vue&type=template&id=c463eb78&scoped=true"
import script from "./browse-configurations-root.view.vue?vue&type=script&lang=ts"
export * from "./browse-configurations-root.view.vue?vue&type=script&lang=ts"
import style0 from "./browse-configurations-root.view.vue?vue&type=style&index=0&id=c463eb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c463eb78",
  null
  
)

export default component.exports